import { ScopeModel as c } from "../../../api/models/scope/scope.model.js";
import { Model as h } from "../../../api/model.js";
class g extends h {
  constructor(t, s, o, i, e, n, r) {
    super(), this.portalId = t, this.scope = s, this.design = o, this.settings = i, this.shop = e, this.widget = n, this.analytics = r;
  }
  getBaseScope() {
    const { baseLocation: t } = this.settings.configuration;
    return t ? new c([], [t]) : this.scope;
  }
}
export {
  g as CustomizationModel
};
//# sourceMappingURL=customization.model.js.map
